import { MoveDocumentModal } from '@monorepo/shared/componentsV2/documents/MoveDocumentModal';
import {
  DocumentFileResponse,
  DocumentFolderWithFileCountResponse,
} from 'mapistry-shared';
import React, { useCallback } from 'react';
import { useUpdateSiteDocument } from '../hooks/useUpdateSiteDocument';

interface MoveSiteDocumentModalProps {
  organizationId: string;
  projectId: string;
  document: DocumentFileResponse;
  folders: DocumentFolderWithFileCountResponse[];
  onClose: () => void;
}

export function MoveSiteDocumentModal({
  organizationId,
  projectId,
  document,
  folders,
  onClose,
}: MoveSiteDocumentModalProps) {
  const [move] = useUpdateSiteDocument({ config: { throwOnError: true } });

  const onMove = useCallback(
    async (folderId: string | null) => {
      await move({
        organizationId,
        projectId,
        documentId: document.id,
        document: { folderId },
      });
    },
    [document.id, move, organizationId, projectId],
  );

  return (
    <MoveDocumentModal
      folders={folders}
      allowTopLevel={document.folderId != null}
      onMove={onMove}
      onClose={onClose}
    />
  );
}
